var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-content--container"},[(_vm.company.iframe_dashboard)?_c('iframe',{attrs:{"src":_vm.company.iframe_dashboard,"frameborder":"0","height":"100%","width":"100%"}}):_c('h2',{staticClass:"admin-no-dashboard-yet"},[_vm._v(" There is no dashboard setup, yet! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }